export default "__VITE_ASSET__BYJfJ5Zk__"